export default "__VITE_ASSET__CeyHWrP$__"